import { useState } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../hooks/useAuth'
import { EonLogo } from './shared/EonLogo'

export function BytLosenordForstaGangen() {
  const { medarbetare, updatePassword, refreshMedarbetare, logOut } = useAuth()
  const [losen1, setLosen1] = useState('')
  const [losen2, setLosen2] = useState('')
  const [visaLosen, setVisaLosen] = useState(false)
  const [fel, setFel] = useState('')
  const [sparar, setSparar] = useState(false)

  async function sparaNyttLosenord(e) {
    e.preventDefault()
    setFel('')

    if (losen1.length < 8) {
      setFel('Lösenordet måste vara minst 8 tecken.')
      return
    }
    if (losen1 !== losen2) {
      setFel('Lösenorden matchar inte – kontrollera att du skrivit lika i båda fälten.')
      return
    }

    setSparar(true)
    try {
      await updatePassword(losen1)
      await supabase.from('medarbetare').update({ maste_byta_losenord: false }).eq('id', medarbetare.id)
      await refreshMedarbetare()
    } catch (err) {
      setFel('Kunde inte spara nytt lösenord: ' + (err?.message || 'okänt fel'))
      setSparar(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <EonLogo size={52} borderRadius={12} style={{ margin: '0 auto 16px' }} />
        <h1>Välj nytt lösenord</h1>
        <p className="login-sub">
          Välkommen, {medarbetare?.fornamn}! Eftersom det här är din första inloggning behöver du välja ett eget lösenord innan du kan fortsätta.
        </p>

        <form onSubmit={sparaNyttLosenord}>
          <label className="form-label">Nytt lösenord</label>
          <div style={{ position: 'relative' }}>
            <input
              className="form-control"
              type={visaLosen ? 'text' : 'password'}
              value={losen1}
              onChange={e => setLosen1(e.target.value)}
              placeholder="Minst 8 tecken"
              autoFocus
              style={{ paddingRight: 40 }}
            />
            <button
              type="button"
              onClick={() => setVisaLosen(v => !v)}
              style={{ position: 'absolute', right: 10, top: 8, background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.1rem', color: '#999' }}
              tabIndex={-1}
              title={visaLosen ? 'Dölj lösenord' : 'Visa lösenord'}
            >
              {visaLosen ? '🙈' : '👁'}
            </button>
          </div>
          <label className="form-label">Upprepa nytt lösenord</label>
          <div style={{ position: 'relative' }}>
            <input
              className="form-control"
              type={visaLosen ? 'text' : 'password'}
              value={losen2}
              onChange={e => setLosen2(e.target.value)}
              placeholder="Skriv samma lösenord igen"
              style={{ paddingRight: 40 }}
            />
            <button
              type="button"
              onClick={() => setVisaLosen(v => !v)}
              style={{ position: 'absolute', right: 10, top: 8, background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.1rem', color: '#999' }}
              tabIndex={-1}
              title={visaLosen ? 'Dölj lösenord' : 'Visa lösenord'}
            >
              {visaLosen ? '🙈' : '👁'}
            </button>
          </div>

          {fel && (
            <div className="info-box info-box-red">{fel}</div>
          )}

          <button className="btn btn-primary btn-full" type="submit" disabled={sparar} style={{ marginTop: 8 }}>
            {sparar ? 'Sparar...' : 'Spara och fortsätt'}
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-full"
            onClick={logOut}
            style={{ marginTop: 8 }}
          >
            Logga ut
          </button>
        </form>
      </div>
    </div>
  )
}
